// Adaptive Test details — edit here only.
// Shown on Join Us → "Adaptive Test" (fee and conductedBy lines, then one card per date + centre + slot) and on the candidate's
// Adaptive Test tab (#cat) in Profile (one table row per slot).
// The test is run entirely by Energia SOI; nothing here is stored in Mensa's database.
// Phase 2 replaces this file with data from the backend; keep the same shape.
//
// HOW TO EDIT
// - fee: a plain number, without GST; shown as "Fee: ₹2000 + GST" above the cards, on the candidate tab and in the FAQ.
// - sessions: one entry per date, written "YYYY-MM-DD" (e.g. 14 Nov 2026 is "2026-11-14").
//   Each date has its own centres; each centre has its own slots.
// - Past dates hide themselves (India time), so old dates can stay or be deleted.
// - address may be "" if unknown (the table shows "—").
// - Keep the commas and quotes exactly as in the example: every { } and [ ] item is followed by a comma.
// - Example: add a second centre on 7 Nov and a new date, 14 Nov, at Mumbai:
//     {
//       date: "2026-11-07",
//       centres: [
//         { name: "Energia SOI Mumbai", city: "Mumbai", address: "...", slots: ["1:00 PM – 3:00 PM", "3:00 PM – 5:00 PM"] },
//         { name: "Energia SOI Pune", city: "Pune", address: "...", slots: ["10:00 AM – 12:00 PM"] },
//       ],
//     },
//     {
//       date: "2026-11-14",
//       centres: [
//         { name: "Energia SOI Mumbai", city: "Mumbai", address: "...", slots: ["1:00 PM – 3:00 PM"] },
//       ],
//     },
// - Check: run `npm test` in Website/ (it fails on a typo), look at localhost:3000, then commit,
//   open a PR and have it deployed. The site only changes after a deploy.
const adaptiveTest = {
  title: "Adaptive Test",
  description: "Mensa Adaptive Test",
  fee: 2000,
  conductedBy: "Tests are conducted by Energia SOI.",
  sessions: [
    {
      date: "2026-11-07",
      centres: [
        {
          name: "Energia SOI Mumbai",
          city: "Mumbai",
          address: "LA 126, Benefice Business House, Mathuradas Mill Compound, N.M. Joshi Marg, Lower Parel, Mumbai, Maharashtra 400013",
          slots: ["1:00 PM – 3:00 PM", "3:00 PM – 5:00 PM"],
        },
      ],
    },
  ],
};

export default adaptiveTest;
